import { useLocation, useNavigate } from "react-router-dom";

const NavBarTitles = ({ titles = [], isReg = false }) => {
  const navigate = useNavigate();
  const location = useLocation();

  return (
    <div className="navbar-scroll-wrapper bg-light rounded p-1 ps-3 pe-3">
      <div className="navbar-scroll-content d-inline-flex gap-2">
        {titles.map((title, index) => {
          const isActive = isReg
            ? location.pathname === title.navigatePath ||
              (location.pathname.includes("demo")
                ? location.pathname.endsWith(`${title.navigatePath}/`)
                : location.pathname.startsWith(`${title.navigatePath}/`))
            : location.pathname === title.navigatePath;

          return (
            <div
              key={index}
              className={`px-4 py-2 rounded text-center fw-medium cursor-pointer 
                ${
                  isActive
                    ? "bg-white fw-bold text-primarycolor shadow-sm border border-light"
                    : "text-dark"
                }`}
              role="button"
              onClick={() => navigate(title?.navigatePath)}
            >
              {title?.name}
            </div>
          );
        })}
      </div>
    </div>
  );
};

export const CustomTabs = ({ tabs = [], activeKey, onChange }) => {
  return (
    <div className="custom-tab-container">
      {tabs.map((tab) => (
        <div
          key={tab.key}
          className={`custom-tab ${activeKey === tab.key ? "active fs18 fw-bold text-primarycolor" : ""} `}
          onClick={() => onChange(tab.key)}
        >
          {tab.label}
        </div>
      ))}
    </div>
  );
};

export const ClassicTabs = ({ titles = [] }) => {
  const navigate = useNavigate();

  return (
    <div className="careers-tab">
      {titles.map((value, inx) => (
        <div
          key={inx}
          className={`${value?.className ? value.className : ""} career-tab-jobpost `}
          onClick={() => navigate(value?.navigatePath)}
        >
          {value?.name}
        </div>
      ))}
    </div>
  );
};

export default NavBarTitles;
